import { useContext } from 'react';
import ConfigProvider from '../../config-provider/index';
export default function usePrefixCls(componentSuffixCls, customizePrefixCls) {
  var _useContext = useContext(ConfigProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var componentCls = getPrefixCls(componentSuffixCls, customizePrefixCls);
  var prefixCls = getPrefixCls('', customizePrefixCls);
  return [componentCls, prefixCls];
}